<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><span class="smallcaps">ABBREVIATIONS</span></h1>
<table class="table">
<tbody>
<tr>
<td class="w30"><p class="t-left"><em>ABD</em></p></td>
<td class="w65"><p class="t-left"><em>Anchor Bible Dictionary</em>. Edited by David Noel Freedman. 6 vols. New York: Doubleday, 1992</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">AnBib</p></td>
<td class="w65"><p class="t-left">Analecta Biblica</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>ANRW</em></p></td>
<td class="w65"><p class="t-left"><em>Aufstieg und Niedergang der römischen Welt</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">AYB</p></td>
<td class="w65"><p class="t-left">Anchor Yale Bible</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>BBR</em></p></td>
<td class="w65"><p class="t-left"><em>Bulletin for Biblical Research</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">BETL</p></td>
<td class="w65"><p class="t-left">Bibliotheca Ephemeridum Theologicarum Lovaniensium</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>Bib</em></p></td>
<td class="w65"><p class="t-left"><em>Biblica</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>BZ</em></p></td>
<td class="w65"><p class="t-left"><em>Biblische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">BZAW</p></td>
<td class="w65"><p class="t-left">Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">BZNW</p></td>
<td class="w65"><p class="t-left">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>CBQ</em></p></td>
<td class="w65"><p class="t-left"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>ER</em></p></td>
<td class="w65"><p class="t-left"><em>The Encyclopedia of Religion</em>. Edited by Mircea Eliade. New York: Macmillan, 1987.</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>ExpTim</em></p></td>
<td class="w65"><p class="t-left"><em>Expository Times</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">FRLANT</p></td>
<td class="w65"><p class="t-left">Forschungen zur Religion und Literatur des Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">Goodspeed</p></td>
<td class="w65"><p class="t-left"><em>The New Testament: An American Translation</em>, by Edgar J. Goodspeed</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">Hart</p></td>
<td class="w65"><p class="t-left"><em>The New Testament: A Translation</em>, by David Bentley Hart</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>HBT</em></p></td>
<td class="w65"><p class="t-left"><em>Horizons in Biblical Theology</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>IDB</em></p></td>
<td class="w65"><p class="t-left"><em>The Interpreter’s Dictionary of the Bible</em>. Edited by George A. Buttrick. 4 vols. New York: Abingdon, 1962.</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>Int</em></p></td>
<td class="w65"><p class="t-left"><em>Interpretation</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>JAAR</em></p></td>
<td class="w65"><p class="t-left"><em>Journal of the American Academy of Religion</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">JB</p></td>
<td class="w65"><p class="t-left">Jerusalem Bible</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>JBL</em></p></td>
<td class="w65"><p class="t-left"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>JSNT</em></p></td>
<td class="w65"><p class="t-left"><em>Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">JSNTSup</p></td>
<td class="w65"><p class="t-left">Journal for the Study of the New Testament Supplement Series</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>JSSR</em></p></td>
<td class="w65"><p class="t-left"><em>Journal for the Scientific Study of Religion</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>JTS</em></p></td>
<td class="w65"><p class="t-left"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">Knox</p></td>
<td class="w65"><p class="t-left"><em>The Holy Bible: A Translation From the Latin Vulgate in the Light of the Hebrew and Greek Originals</em>, by Ronald Knox</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">KJV</p></td>
<td class="w65"><p class="t-left">King James Version</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">LCL</p></td>
<td class="w65"><p class="t-left">Loeb Classical Library</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">LXX</p></td>
<td class="w65"><p class="t-left">Septuagint</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">Moffatt</p></td>
<td class="w65"><p class="t-left"><em>The New Testament: A New Translation</em>, by James Moffatt</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">MS(S)</p></td>
<td class="w65"><p class="t-left">manuscript(s)</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">NAB</p></td>
<td class="w65"><p class="t-left">New American Bible</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">NABRE</p></td>
<td class="w65"><p class="t-left">New American Bible Revised Edition</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>NE</em></p></td>
<td class="w65"><p class="t-left"><em>Nicomachean Ethics</em> (Aristotle)</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">NEB</p></td>
<td class="w65"><p class="t-left">New English Bible</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">NICNT</p></td>
<td class="w65"><p class="t-left">New International Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">NIGTC</p></td>
<td class="w65"><p class="t-left">New International Greek Testament Commentary</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">NIV</p></td>
<td class="w65"><p class="t-left">New International Version</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">NJB</p></td>
<td class="w65"><p class="t-left">New Jerusalem Bible</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>NovT</em></p></td>
<td class="w65"><p class="t-left"><em>Novum Testamentum</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">NovTSup</p></td>
<td class="w65"><p class="t-left">Supplements to Novum Testamentum</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">NRSV</p></td>
<td class="w65"><p class="t-left">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>NTS</em></p></td>
<td class="w65"><p class="t-left"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">PIBA</p></td>
<td class="w65"><p class="t-left">Proceedings of the Irish Biblical Association</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>PRSt</em></p></td>
<td class="w65"><p class="t-left"><em>Perspectives in Religious Studies</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">QD</p></td>
<td class="w65"><p class="t-left">Quaestiones Disputatae</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>RB</em></p></td>
<td class="w65"><p class="t-left"><em>Revue Biblique</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>RSR</em></p></td>
<td class="w65"><p class="t-left"><em>Recherches de science religieuse</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">RSV</p></td>
<td class="w65"><p class="t-left">Revised Standard Version</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SBLDS</p></td>
<td class="w65"><p class="t-left">Society of Biblical Literature Dissertation Series</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SBLMS</p></td>
<td class="w65"><p class="t-left">Society of Biblical Literature Monograph Series</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SBLSBS</p></td>
<td class="w65"><p class="t-left">Society of Biblical Literature Sources for Biblical Study</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SBLSP</p></td>
<td class="w65"><p class="t-left">Society of Biblical Literature Seminar Papers</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SBLTT</p></td>
<td class="w65"><p class="t-left">Society of Biblical Literature Texts and Translations</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SBT</p></td>
<td class="w65"><p class="t-left">Studies in Biblical Theology</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SCJ</p></td>
<td class="w65"><p class="t-left">Studies in Christianity and Judaism</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SNTSMS</p></td>
<td class="w65"><p class="t-left">Society for New Testament Studies Monograph Series</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SNTW</p></td>
<td class="w65"><p class="t-left">Studies of the New Testament and Its World</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">SP</p></td>
<td class="w65"><p class="t-left">Sacra Pagina</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>SR</em></p></td>
<td class="w65"><p class="t-left"><em>Studies in Religion</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>ST</em></p></td>
<td class="w65"><p class="t-left"><em>Studia Theologica</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>TD</em></p></td>
<td class="w65"><p class="t-left"><em>Theology Digest</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>TDNT</em></p></td>
<td class="w65"><p class="t-left"><em>Theological Dictionary of the New Testament</em>. Edited by Gerhard Kittel and Gerhard Friedrich. Translated by Geoffrey W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–1976.</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>TNT</em></p></td>
<td class="w65"><p class="t-left"><em>Theology of the New Testament</em> (Bultmann)</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">TS</p></td>
<td class="w65"><p class="t-left">Texts and Studies</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>TJ</em></p></td>
<td class="w65"><p class="t-left"><em>Trinity Journal</em></p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">TUGAL</p></td>
<td class="w65"><p class="t-left">Texte und Untersuchungen zur Geschichte der altchristlichen Literatur</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">WBC</p></td>
<td class="w65"><p class="t-left">Word Biblical Commentary</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left">WUNT</p></td>
<td class="w65"><p class="t-left">Wissenschaftliche Untersuchungen zum Neuen Testament</p></td>
</tr>
<tr>
<td class="w30"><p class="t-left"><em>ZNW</em></p></td>
<td class="w65"><p class="t-left"><em>Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche</em></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Abbreviations.vue?88ca37cc